var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool-unsupported"},[_c('h2',[_vm._v("Oh dear, incompatible browser!")]),_c('p',[_vm._v("Sorry, but this interactive tool is currently only supported by recent versions of Chrome, Firefox, and Safari. IE/Edge is currently not available.")])])
}]

export { render, staticRenderFns }